import { Avatar } from '@mui/material';
import React from 'react';

/**
 * @param {object} props
 * @returns {React.ReactNode}
 */
export const UserAvatar = (props) => {
    const username = props.username || '';
    const margin = props.margin === 'no' ? '-26px' : '1rem';
    const randomFromString = ((username.length + username.charCodeAt(0)) % 32) / 32;
    const color = `hsl(${randomFromString * 360},60%,40%)`;
    const firstLetters = (username.match(/\b(\w)/g) || [])
        .slice(0, 2) // max 2 letters
        .join('')
        .toUpperCase();
    return (
        <Avatar sx={{ backgroundColor: color, marginRight: margin, border: 'solid 3px #F9F9F9' }}>
            {firstLetters}
        </Avatar>
    );
};
